import { render, staticRenderFns } from "./SingleTag.vue?vue&type=template&id=5c8625f0"
import script from "./SingleTag.vue?vue&type=script&lang=js"
export * from "./SingleTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports